import { getShowPatientSection } from '../../hooks/getShowPatientSection';

export enum RequestType {
  PatientRegistration = 'PATIENT_REGISTRATION',
  DoctorRegistration = 'DOCTOR_REGISTRATION',
  ReceiptOrder = 'RECEIPT_ORDER'
}

export namespace RequestType {
  export function isRegistration(requestType?: RequestType): boolean {
    return requestType === RequestType.DoctorRegistration || requestType === RequestType.PatientRegistration;
  }
}

export const defaultRequestType = getShowPatientSection() ? RequestType.ReceiptOrder : RequestType.DoctorRegistration;
